module.exports = __webpack_public_path__ + "static/media/Audience.766a0c56.png";